import { Component } from '@angular/core';

@Component({
  selector: 'app-participant-list',
  templateUrl: './participant-list.component.html',
  styleUrls: ['./participant-list.component.scss']
})
export class ParticipantListComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// /dist/src/app/user/participant/participant-list/participant-list.component.ts